import { createFileRoute, redirect } from "@tanstack/react-router";

/** Shopify's app-install URL; forwards the install params to the Shopify connect page, whose guard adds login if needed. */
export const Route = createFileRoute("/shopify/install")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/user/apps/shopify", search, replace: true });
  },
});
